var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.515 16.286h-3.602a2.395 2.395 0 110-4.79h3.602M16.703 13.838H16.7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.122 6.163l7.692-.034a4.671 4.671 0 014.69 4.65l.025 5.498a4.671 4.671 0 01-4.65 4.69l-7.692.034a4.67 4.67 0 01-4.69-4.65l-.025-5.497a4.67 4.67 0 014.65-4.691z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 10.182h4.805M4.8 7.569c-.018-1.78.805-3.267 2.61-3.534l6.94-.996c1.975-.293 3.265 1.113 3.558 3.097l.072.437",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgWalletDouble;